/*───────────────────────────────────────────────────────────────
 📄 File: i18n/i18nResources.ts
 🧩 Description:
    Loads all translation JSON files and assembles the 'resources'
    object for i18next. Extracted from i18n/index.ts.
    Add new namespaces here - one import + one entry in the object.
────────────────────────────────────────────────────────────────*/

// ── English ───────────────────────────────────────────────────
import enCommon from './en/common.json';
import enAuth from './en/auth.json';
import enProfiles from './en/profiles.json';
import enRoleProfiles from './en/roleProfiles.json';
import enLogProfiles from './en/logProfiles.json';
import enApiKeys from './en/apiKeys.json';
import enSystemMisc from './en/systemMisc.json';
import enUsers from './en/users.json';
import enEmailSettings from './en/emailSettings.json';
import enLoggingSettings from './en/loggingSettings.json';
import enTelephonyServers from './en/telephonyServers.json';
import enTelephonyDomains from './en/telephonyDomains.json';
import enTenants from './en/tenants.json';
import enAppearance from './en/appearance.json';
import enMenu from './en/menu.json';
import enProfile from './en/profile.json';
import enBranding from './en/branding.json';
import enSipProfiles from './en/sipProfiles.json';
import enSipParameters from './en/sipParameters.json';
import enFeatureCodes from './en/featureCodes.json';
import enFeatureCategories from './en/featureCategories.json';
import enGateways from './en/gateways.json';
import enGatewaySipProfiles from './en/gatewaySipProfiles.json';
import enDeviceSipProfiles from './en/deviceSipProfiles.json';
import enDialRuleRestrictions from './en/dialRuleRestrictions.json';
import enClassOfServices from './en/classOfServices.json';
import enOutboundRoutes from './en/outboundRoutes.json';
import enInboundRoutes from './en/inboundRoutes.json';
import enTimeGroups from './en/timeGroups.json';
import enTimeConditions from './en/timeConditions.json';
import enArs from './en/ars.json';
import enPinLists from './en/pinLists.json';
import enExtensions from './en/extensions.json';
import enSystemGeneral from './en/systemGeneral.json';
import enSystemVars from './en/systemVars.json';
import enNetworkSettings from './en/networkSettings.json';
import enPhonebooks from './en/phonebooks.json';
import enHotDesking from './en/hotDesking.json';
import enBulkModification from './en/bulkModification.json';
import enConferences from './en/conferences.json';
import enConferenceProfiles from './en/conferenceProfiles.json';
import enFormBuilder from './en/formBuilder.json';
import enBlacklist from './en/blacklist.json';
import enAiProfiles from './en/aiProfiles.json';
import enAiProviders from './en/aiProviders.json';
import enAiAgents from './en/aiAgents.json';
import enRecordingManagement from './en/recordingManagement.json';
import enVoiceGuides from './en/voiceGuides.json';
import enMohSources from './en/mohSources.json';
import enDirectDial from './en/directDial.json';
import enDirectRoute from './en/directRoute.json';
import enVoipbl from './en/voipbl.json';
import enPagingGroups from './en/pagingGroups.json';
import enPickupGroups from './en/pickupGroups.json';
import enParkingLots from './en/parkingLots.json';
import enSpeedDials from './en/speedDials.json';
import enEslUsers from './en/eslUsers.json';
import enRingGroups from './en/ringGroups.json';
import enQueues from './en/queues.json';
import enQueueProfiles from './en/queueProfiles.json';
import enAgents from './en/agents.json';
import enCallbackProfiles from './en/callbackProfiles.json';
import enVIPLists from './en/vipLists.json';
import enDynamicDestination from './en/dynamicDestination.json';
import enDialProfiles from './en/dialProfiles.json';
import enVoicemailSettings from './en/voicemailSettings.json';
import enCdrSettings from './en/cdrSettings.json';
import enCdrFilters from './en/cdrFilters.json';
import enCallDetailRecords from './en/callDetailRecords.json';
import enIVRs from './en/ivrs.json';
import enFaxDevices from './en/faxDevices.json';
import enFaxSending from './en/faxSending.json';
import enFaxViewer from './en/faxViewer.json';
import enEmergencyNumbers from './en/emergencyNumbers.json';
import enDispatchLocations from './en/dispatchLocations.json';
import enDisaEntries from './en/disaEntries.json';
import enCallbackRules from './en/callbackRules.json';
import enVoicemailsBroadcastGroups from './en/voicemailsBroadcastGroups.json';
import enAnnouncements from './en/announcements.json';
import enLanguages from './en/languages.json';
import enCallFlows from './en/callFlows.json';
import enAuthenticationCodes from './en/authenticationCodes.json';
import enCidModifiers from './en/cidModifiers.json';
import enCallerIdLookupSources from './en/callerIdLookupSources.json';
import enPbxCli from './en/pbxCli.json';
import enCustomerCodes from './en/customerCodes.json';
import enAuthorizationCodes from './en/authorizationCodes.json';
import enAuditLogs from './en/auditLogs.json';
import enUserActivity from './en/userActivity.json';
import enChangeHistory from './en/changeHistory.json';
import enSecurityLogs from './en/securityLogs.json';
import enIVRStats from './en/ivrStats.json';
import enFirewallServices from './en/firewallServices.json';
import enFirewallRules from './en/firewallRules.json';
import enGeoFirewall from './en/geoFirewall.json';
import enAccessControl from './en/accessControl.json';
import enFirewallSettings from './en/firewallSettings.json';
import enPriorityRouting from './en/priorityRouting.json';
import enLogViewer from './en/logViewer.json';
import enProvisioning from './en/provisioning.json';
import enProvisioningTemplates from './en/provisioningTemplates.json';
import enProvisioningSecurity from './en/provisioningSecurity.json';
import enProvisioningVendors from './en/provisioningVendors.json';
import enProvisioningDeviceModels from './en/provisioningDeviceModels.json';
import enProvisioningDevices from './en/provisioningDevices.json';
import enBackupRestore from './en/backupRestore.json';
import enCronProfiles from './en/cronProfiles.json';
import enSystemCleanup from './en/systemCleanup.json';
import enEmailTemplates from './en/emailTemplates.json';
import enSipEndpoints from './en/sipEndpoints.json';
import enActiveCalls from './en/activeCalls.json';
import enCustomTasks from './en/customTasks.json';
import enCertificates from './en/certificates.json';
import enHttpServer from './en/httpServer.json';
import enOpenvpn from './en/openvpn.json';
import enOpenvpnClient from './en/openvpnClient.json';
import enDashboard from './en/dashboard.json';
import enCrm from './en/crm.json';
import enIntegrations from './en/integrations.json';
import enDynamicRouting from './en/dynamicRouting.json';
import enQueueCallbackReport from './en/queueCallbackReport.json';
import enCustomApplications from './en/customApplications.json';
import enSms from './en/sms.json';
import enAiToolProfiles from './en/aiToolProfiles.json';
import enLicensing from './en/licensing.json';
import enAcl from './en/acl.json';

// ── Spanish ───────────────────────────────────────────────────
import esCommon from './es/common.json';
import esAuth from './es/auth.json';
import esProfiles from './es/profiles.json';
import esRoleProfiles from './es/roleProfiles.json';
import esLogProfiles from './es/logProfiles.json';
import esApiKeys from './es/apiKeys.json';
import esSystemMisc from './es/systemMisc.json';
import esUsers from './es/users.json';
import esEmailSettings from './es/emailSettings.json';
import esLoggingSettings from './es/loggingSettings.json';
import esTelephonyServers from './es/telephonyServers.json';
import esTelephonyDomains from './es/telephonyDomains.json';
import esTenants from './es/tenants.json';
import esAppearance from './es/appearance.json';
import esMenu from './es/menu.json';
import esProfile from './es/profile.json';
import esBranding from './es/branding.json';
import esSipProfiles from './es/sipProfiles.json';
import esSipParameters from './es/sipParameters.json';
import esFeatureCodes from './es/featureCodes.json';
import esFeatureCategories from './es/featureCategories.json';
import esGateways from './es/gateways.json';
import esGatewaySipProfiles from './es/gatewaySipProfiles.json';
import esDeviceSipProfiles from './es/deviceSipProfiles.json';
import esDialRuleRestrictions from './es/dialRuleRestrictions.json';
import esClassOfServices from './es/classOfServices.json';
import esOutboundRoutes from './es/outboundRoutes.json';
import esInboundRoutes from './es/inboundRoutes.json';
import esTimeGroups from './es/timeGroups.json';
import esTimeConditions from './es/timeConditions.json';
import esArs from './es/ars.json';
import esPinLists from './es/pinLists.json';
import esExtensions from './es/extensions.json';
import esSystemGeneral from './es/systemGeneral.json';
import esSystemVars from './es/systemVars.json';
import esNetworkSettings from './es/networkSettings.json';
import esPhonebooks from './es/phonebooks.json';
import esHotDesking from './es/hotDesking.json';
import esBulkModification from './es/bulkModification.json';
import esConferences from './es/conferences.json';
import esConferenceProfiles from './es/conferenceProfiles.json';
import esFormBuilder from './es/formBuilder.json';
import esBlacklist from './es/blacklist.json';
import esAiProfiles from './es/aiProfiles.json';
import esAiProviders from './es/aiProviders.json';
import esAiAgents from './es/aiAgents.json';
import esVoipbl from './es/voipbl.json';
import esRecordingManagement from './es/recordingManagement.json';
import esVoiceGuides from './es/voiceGuides.json';
import esMohSources from './es/mohSources.json';
import esDirectDial from './es/directDial.json';
import esDirectRoute from './es/directRoute.json';
import esPagingGroups from './es/pagingGroups.json';
import esPickupGroups from './es/pickupGroups.json';
import esParkingLots from './es/parkingLots.json';
import esSpeedDials from './es/speedDials.json';
import esEslUsers from './es/eslUsers.json';
import esRingGroups from './es/ringGroups.json';
import esQueues from './es/queues.json';
import esQueueProfiles from './es/queueProfiles.json';
import esAgents from './es/agents.json';
import esCallbackProfiles from './es/callbackProfiles.json';
import esVIPLists from './es/vipLists.json';
import esDynamicDestination from './es/dynamicDestination.json';
import esDialProfiles from './es/dialProfiles.json';
import esVoicemailSettings from './es/voicemailSettings.json';
import esCdrSettings from './es/cdrSettings.json';
import esCdrFilters from './es/cdrFilters.json';
import esCallDetailRecords from './es/callDetailRecords.json';
import esIVRs from './es/ivrs.json';
import esFaxDevices from './es/faxDevices.json';
import esFaxSending from './es/faxSending.json';
import esFaxViewer from './es/faxViewer.json';
import esEmergencyNumbers from './es/emergencyNumbers.json';
import esDispatchLocations from './es/dispatchLocations.json';
import esDisaEntries from './es/disaEntries.json';
import esCallbackRules from './es/callbackRules.json';
import esVoicemailsBroadcastGroups from './es/voicemailsBroadcastGroups.json';
import esAnnouncements from './es/announcements.json';
import esLanguages from './es/languages.json';
import esCallFlows from './es/callFlows.json';
import esAuthenticationCodes from './es/authenticationCodes.json';
import esCidModifiers from './es/cidModifiers.json';
import esCallerIdLookupSources from './es/callerIdLookupSources.json';
import esPbxCli from './es/pbxCli.json';
import esCustomerCodes from './es/customerCodes.json';
import esAuthorizationCodes from './es/authorizationCodes.json';
import esAuditLogs from './es/auditLogs.json';
import esUserActivity from './es/userActivity.json';
import esChangeHistory from './es/changeHistory.json';
import esSecurityLogs from './es/securityLogs.json';
import esIVRStats from './es/ivrStats.json';
import esFirewallServices from './es/firewallServices.json';
import esFirewallRules from './es/firewallRules.json';
import esGeoFirewall from './es/geoFirewall.json';
import esAccessControl from './es/accessControl.json';
import esFirewallSettings from './es/firewallSettings.json';
import esPriorityRouting from './es/priorityRouting.json';
import esLogViewer from './es/logViewer.json';
import esProvisioning from './es/provisioning.json';
import esProvisioningTemplates from './es/provisioningTemplates.json';
import esProvisioningSecurity from './es/provisioningSecurity.json';
import esProvisioningVendors from './es/provisioningVendors.json';
import esProvisioningDeviceModels from './es/provisioningDeviceModels.json';
import esProvisioningDevices from './es/provisioningDevices.json';
import esBackupRestore from './es/backupRestore.json';
import esCronProfiles from './es/cronProfiles.json';
import esSystemCleanup from './es/systemCleanup.json';
import esEmailTemplates from './es/emailTemplates.json';
import esSipEndpoints from './es/sipEndpoints.json';
import esActiveCalls from './es/activeCalls.json';
import esCustomTasks from './es/customTasks.json';
import esCertificates from './es/certificates.json';
import esHttpServer from './es/httpServer.json';
import esOpenvpn from './es/openvpn.json';
import esOpenvpnClient from './es/openvpnClient.json';
import esDashboard from './es/dashboard.json';
import esCrm from './es/crm.json';
import esIntegrations from './es/integrations.json';
import esDynamicRouting from './es/dynamicRouting.json';
import esQueueCallbackReport from './es/queueCallbackReport.json';
import esCustomApplications from './es/customApplications.json';
import esSms from './es/sms.json';
import esAiToolProfiles from './es/aiToolProfiles.json';
import esLicensing from './es/licensing.json';
import esAcl from './es/acl.json';

// ── Resources object ──────────────────────────────────────────
const NS_EN = {
  common: enCommon, auth: enAuth, profiles: enProfiles, roleProfiles: enRoleProfiles,
  logProfiles: enLogProfiles, apiKeys: enApiKeys, systemMisc: enSystemMisc,
  users: enUsers, emailSettings: enEmailSettings, loggingSettings: enLoggingSettings,
  telephonyServers: enTelephonyServers, telephonyDomains: enTelephonyDomains,
  tenants: enTenants, appearance: enAppearance, menu: enMenu, profile: enProfile,
  branding: enBranding, sipProfiles: enSipProfiles, sipParameters: enSipParameters,
  featureCodes: enFeatureCodes, featureCategories: enFeatureCategories,
  gateways: enGateways, gatewaySipProfiles: enGatewaySipProfiles,
  deviceSipProfiles: enDeviceSipProfiles, dialRuleRestrictions: enDialRuleRestrictions,
  classOfServices: enClassOfServices, outboundRoutes: enOutboundRoutes,
  inboundRoutes: enInboundRoutes, timeGroups: enTimeGroups, timeConditions: enTimeConditions,
  ars: enArs, pinLists: enPinLists, extensions: enExtensions,
  systemGeneral: enSystemGeneral, systemVars: enSystemVars,
  networkSettings: enNetworkSettings, phonebooks: enPhonebooks,
  hotDesking: enHotDesking, bulkModification: enBulkModification,
  conferences: enConferences, conferenceProfiles: enConferenceProfiles,
  formBuilder: enFormBuilder, blacklist: enBlacklist,
  aiProfiles: enAiProfiles, aiProviders: enAiProviders, aiAgents: enAiAgents,
  voipbl: enVoipbl,
  recordingManagement: enRecordingManagement, voiceGuides: enVoiceGuides,
  mohSources: enMohSources, directDial: enDirectDial, directRoute: enDirectRoute,
  pagingGroups: enPagingGroups, pickupGroups: enPickupGroups, parkingLots: enParkingLots,
  speedDials: enSpeedDials, eslUsers: enEslUsers, ringGroups: enRingGroups,
  queues: enQueues, queueProfiles: enQueueProfiles, agents: enAgents,
  callbackProfiles: enCallbackProfiles, vipLists: enVIPLists,
  dynamicDestination: enDynamicDestination, dialProfiles: enDialProfiles,
  voicemailSettings: enVoicemailSettings, cdrSettings: enCdrSettings,
  cdrFilters: enCdrFilters, callDetailRecords: enCallDetailRecords,
  ivrs: enIVRs, faxDevices: enFaxDevices, faxSending: enFaxSending, faxViewer: enFaxViewer,
  emergencyNumbers: enEmergencyNumbers, dispatchLocations: enDispatchLocations,
  disaEntries: enDisaEntries, callbackRules: enCallbackRules,
  voicemailsBroadcastGroups: enVoicemailsBroadcastGroups, announcements: enAnnouncements,
  languages: enLanguages, callFlows: enCallFlows,
  authenticationCodes: enAuthenticationCodes, cidModifiers: enCidModifiers,
  callerIdLookupSources: enCallerIdLookupSources, pbxCli: enPbxCli,
  customerCodes: enCustomerCodes, authorizationCodes: enAuthorizationCodes,
  auditLogs: enAuditLogs, userActivity: enUserActivity, changeHistory: enChangeHistory,
  securityLogs: enSecurityLogs, ivrStats: enIVRStats,
  firewallServices: enFirewallServices, firewallRules: enFirewallRules,
  geoFirewall: enGeoFirewall, accessControl: enAccessControl, firewallSettings: enFirewallSettings,
  priorityRouting: enPriorityRouting, logViewer: enLogViewer,
  provisioning: enProvisioning, provisioningTemplates: enProvisioningTemplates,
  provisioningSecurity: enProvisioningSecurity, provisioningVendors: enProvisioningVendors,
  provisioningDeviceModels: enProvisioningDeviceModels, provisioningDevices: enProvisioningDevices,
  backupRestore: enBackupRestore, cronProfiles: enCronProfiles, systemCleanup: enSystemCleanup,
  emailTemplates: enEmailTemplates, sipEndpoints: enSipEndpoints, activeCalls: enActiveCalls,
  customTasks: enCustomTasks, certificates: enCertificates, httpServer: enHttpServer,
  openvpn: enOpenvpn, openvpnClient: enOpenvpnClient,
  dashboard: enDashboard, crm: enCrm, integrations: enIntegrations,
  dynamic_routing: enDynamicRouting, queueCallbackReport: enQueueCallbackReport,
  customApplications: enCustomApplications, sms: enSms, licensing: enLicensing,
  aiToolProfiles: enAiToolProfiles, acl: enAcl,
};

const NS_ES = {
  common: esCommon, auth: esAuth, profiles: esProfiles, roleProfiles: esRoleProfiles,
  logProfiles: esLogProfiles, apiKeys: esApiKeys, systemMisc: esSystemMisc,
  users: esUsers, emailSettings: esEmailSettings, loggingSettings: esLoggingSettings,
  telephonyServers: esTelephonyServers, telephonyDomains: esTelephonyDomains,
  tenants: esTenants, appearance: esAppearance, menu: esMenu, profile: esProfile,
  branding: esBranding, sipProfiles: esSipProfiles, sipParameters: esSipParameters,
  featureCodes: esFeatureCodes, featureCategories: esFeatureCategories,
  gateways: esGateways, gatewaySipProfiles: esGatewaySipProfiles,
  deviceSipProfiles: esDeviceSipProfiles, dialRuleRestrictions: esDialRuleRestrictions,
  classOfServices: esClassOfServices, outboundRoutes: esOutboundRoutes,
  inboundRoutes: esInboundRoutes, timeGroups: esTimeGroups, timeConditions: esTimeConditions,
  ars: esArs, pinLists: esPinLists, extensions: esExtensions,
  systemGeneral: esSystemGeneral, systemVars: esSystemVars,
  networkSettings: esNetworkSettings, phonebooks: esPhonebooks,
  hotDesking: esHotDesking, bulkModification: esBulkModification,
  conferences: esConferences, conferenceProfiles: esConferenceProfiles,
  formBuilder: esFormBuilder, blacklist: esBlacklist,
  aiProfiles: esAiProfiles, aiProviders: esAiProviders, aiAgents: esAiAgents,
  voipbl: esVoipbl,
  recordingManagement: esRecordingManagement, voiceGuides: esVoiceGuides,
  mohSources: esMohSources, directDial: esDirectDial, directRoute: esDirectRoute,
  pagingGroups: esPagingGroups, pickupGroups: esPickupGroups, parkingLots: esParkingLots,
  speedDials: esSpeedDials, eslUsers: esEslUsers, ringGroups: esRingGroups,
  queues: esQueues, queueProfiles: esQueueProfiles, agents: esAgents,
  callbackProfiles: esCallbackProfiles, vipLists: esVIPLists,
  dynamicDestination: esDynamicDestination, dialProfiles: esDialProfiles,
  voicemailSettings: esVoicemailSettings, cdrSettings: esCdrSettings,
  cdrFilters: esCdrFilters, callDetailRecords: esCallDetailRecords,
  ivrs: esIVRs, faxDevices: esFaxDevices, faxSending: esFaxSending, faxViewer: esFaxViewer,
  emergencyNumbers: esEmergencyNumbers, dispatchLocations: esDispatchLocations,
  disaEntries: esDisaEntries, callbackRules: esCallbackRules,
  voicemailsBroadcastGroups: esVoicemailsBroadcastGroups, announcements: esAnnouncements,
  languages: esLanguages, callFlows: esCallFlows,
  authenticationCodes: esAuthenticationCodes, cidModifiers: esCidModifiers,
  callerIdLookupSources: esCallerIdLookupSources, pbxCli: esPbxCli,
  customerCodes: esCustomerCodes, authorizationCodes: esAuthorizationCodes,
  auditLogs: esAuditLogs, userActivity: esUserActivity, changeHistory: esChangeHistory,
  securityLogs: esSecurityLogs, ivrStats: esIVRStats,
  firewallServices: esFirewallServices, firewallRules: esFirewallRules,
  geoFirewall: esGeoFirewall, accessControl: esAccessControl, firewallSettings: esFirewallSettings,
  priorityRouting: esPriorityRouting, logViewer: esLogViewer,
  provisioning: esProvisioning, provisioningTemplates: esProvisioningTemplates,
  provisioningSecurity: esProvisioningSecurity, provisioningVendors: esProvisioningVendors,
  provisioningDeviceModels: esProvisioningDeviceModels, provisioningDevices: esProvisioningDevices,
  backupRestore: esBackupRestore, cronProfiles: esCronProfiles, systemCleanup: esSystemCleanup,
  emailTemplates: esEmailTemplates, sipEndpoints: esSipEndpoints, activeCalls: esActiveCalls,
  customTasks: esCustomTasks, certificates: esCertificates, httpServer: esHttpServer,
  openvpn: esOpenvpn, openvpnClient: esOpenvpnClient,
  dashboard: esDashboard, crm: esCrm, integrations: esIntegrations,
  dynamic_routing: esDynamicRouting, queueCallbackReport: esQueueCallbackReport,
  customApplications: esCustomApplications, sms: esSms, licensing: esLicensing,
  aiToolProfiles: esAiToolProfiles, acl: esAcl,
};

export const i18nResources = { en: NS_EN, es: NS_ES };

/** All registered namespace keys (derived from English namespace object) */
export const i18nNamespaces = Object.keys(NS_EN) as (keyof typeof NS_EN)[];
